import React from 'react'
import { Switch as SwitchDS } from '@jisr-hr/ds'

const Switch = (props) => <SwitchDS {...props} />

export default Switch
